import _ from 'lodash';
//constants
import { field } from '../types';
import { FormControl, TextField, FormHelperText, Autocomplete } from '@mui/material';
import { getErrorText } from '..';
import { CustomTextField } from 'theme/elements/Inputs';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange: any;
};

export default function SelectAutocomplete(props: props) {
	const t = useAppSelector(selectTranslations);
	const { valid, cField, handleChange, initialValidation } = props;
	const { name, value, label, placeholder, options, disabled } = cField.props;
	const isDisabled = disabled;
	let inputValue: { value: any; label: string } | null = null;
	const extraProps = {};
	if (_.has(cField, 'renderInput')) {
		extraProps['renderInput'] = cField.renderInput;
	}
	if (_.has(cField, 'getOptionDisabled')) {
		extraProps['getOptionDisabled'] = cField.getOptionDisabled;
	}
	if (_.has(cField, 'renderOption')) {
		extraProps['renderOption'] = cField.renderOption;
	}
	const prepareOptions = () => {
		const list: { value: any; label: string }[] = [];
		if (options?.map) {
			options.map((option, idx) => {
				const val = cField.valueProperty ? option[cField.valueProperty] : option.value;
				const lab = cField.labelProperty ? option[cField.labelProperty] : t(option.label);
				inputValue = value === val ? { value: val, label: lab } : inputValue;
				list.push({
					...option,
					value: val,
					label: lab,
				});
			});
		}
		return list;
	};
	return (
		<CustomTextField key={name}>
			<FormControl error={!valid} fullWidth sx={cField.styleObj}>
				<Autocomplete
					options={prepareOptions()}
					value={inputValue}
					isOptionEqualToValue={(option, value) => option.value == value.value}
					onChange={(event, params) => {
						handleChange({ target: { value: params?.value, name: name } });
					}}
					disabled={disabled}
					renderInput={(params) => {
						return (
							<TextField
								{...params}
								{...cField.props}
								error={!valid}
								label={label}
								name={name}
								variant="filled"
								placeholder={placeholder}
								disabled={isDisabled}
							/>
						);
					}}
					ListboxProps={cField.ListboxProps}
					{...extraProps}
				/>
				<FormHelperText error={!valid}>{t(getErrorText(initialValidation, name))}</FormHelperText>
			</FormControl>
		</CustomTextField>
	);
}
